
<template>
  <div>
    <!--商品详情-->
    <div class="crumbs_xs">
      <div class="preview-hd">
        <div class="preview-picture">
          <div class="preview-pic">
            <detail-video ref="detailVideo"></detail-video>
          </div>
          <!--滑动小图-->
          <div class="pre-small-swiper">
            <swiper :options="swiperOption" ref="mySwiper">
              <!--<swiper-slide :style="swiperStyle">-->
              <el-upload
                class="xs_shiyi"
                :action="url"
                :file-list="addForm.files"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                :data="data"
                :on-success="uploadSuccess"
                ><i class="pic_tu"></i>
              </el-upload>
              <!--</swiper-slide>-->
            </swiper>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
            <div class="cover-prev"></div>
            <div class="cover-next"></div>
          </div>
        </div>
        <!--编辑选择类型-->
        <div class="preview-hd-info">
          <div>
            <i
              style="
                color: red;
                margin-top: 10px;
                position: absolute;
                margin-left: -14px;
              "
              >*</i
            >
            <el-select
              v-model="value"
              value-key="selectItemIds"
              placeholder="选择产品分类"
              @change="selectIds(value)"
            >
              <el-option
                v-for="item in types"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              ></el-option>
            </el-select>
          </div>

          <div class="flex" v-if="SubTypes != ''">
            <i
              style="
                color: red;
                margin-top: 25px;
                position: absolute;
                margin-left: -14px;
              "
              v-if="tureF"
              >*</i
            >
            <div
              class="type flex"
              v-for="(item, index) in SubTypes"
              :class="{ typle: item.state }"
              style="height: 22px; line-height: 12px"
              v-if="selectItemIds == item.StoreTypeId"
            >
              <label class="vote-more-checkbox padin">
                <span class="check-title" :class="{ font: item.state }">{{
                  item.Name
                }}</span>
                <input
                  type="checkbox"
                  v-model="infotypesItem"
                  @change="suJClick(item, index)"
                  :value="item.title"
                />
                <i :class="item.state == true ? 'min_hook' : 'min_hook1'"></i>
              </label>
            </div>
          </div>
          <i
            class="el-icon-loading"
            v-if="tureF && SubTypes == ''"
            style="position: relative; top: 8px; left: 20px"
          ></i>
          <div>
            <i
              style="
                color: red;
                margin-top: 23px;
                position: absolute;
                margin-left: -14px;
              "
              >*</i
            >
            <el-input
              v-model="input1"
              placeholder="请登记您的产品名称"
              class="inp"
            ></el-input>
            <el-input
              v-model="input2"
              placeholder="请编辑SEO关键字"
              class="inp"
            ></el-input>
            <el-input
              v-model="input_seo"
              placeholder="请编辑SEO描述"
              class="inp"
            ></el-input>
            <el-input
              v-model="input_Pc"
              placeholder="活动页链接(PC)"
              class="inp"
            ></el-input>
            <el-input
              v-model="input_M"
              placeholder="活动页链接(手机)"
              class="inp"
            ></el-input>
          </div>
          <div class="goods-classify">
            <i
              style="
                color: red;
                margin-top: 19px;
                position: absolute;
                margin-left: -12px;
              "
              >*</i
            >
            <span class="c-label">淘宝价：</span>
            <span class="c-price"
              >￥
              <el-input
                v-model="input3"
                placeholder="请输入价格"
                class="inp170"
              ></el-input
            ></span>
            <span class="c-label" style="margin-left: 50px">活动价：</span>
            <span class="c-price"
              >￥
              <el-input
                v-model="input_Activity"
                placeholder="请输入活动价"
                class="inp170"
              ></el-input
            ></span>
          </div>
          <div class="goods-classify">
            <div class="classify-label">型号：</div>
            <span class="c-price add addType"
              ><i
                style="
                  color: red;
                  margin-top: 3px;
                  position: absolute;
                  margin-left: -13px;
                "
                >*</i
              >型号添加</span
            >
            <span class="c-price add addJanjie"
              ><i
                style="
                  color: red;
                  margin-top: 3px;
                  position: absolute;
                  margin-left: -9px;
                "
                >*</i
              >简介添加</span
            >
          </div>
          <div class="ba5">
            <div class="baleft">
              <div class="max_he">
                <P
                  v-for="(text, index) in modelList"
                  @mouseenter="videoPlayback(text, index)"
                  @mouseleave="videoStopped"
                >
                  <span
                    class="detail"
                    style="
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      width: 182px;
                    "
                    >{{ text }}</span
                  >
                  <label v-if="hovernum == index">
                    <!--:class="hovernum==index ? 'red':''" -->
                    <label
                      @click="deletes(index)"
                      :class="hovernum == index ? 'red' : 'del'"
                      >删除</label
                    >
                    <label class="line">|</label>
                    <label
                      @click="modify(text, index)"
                      :class="hovernum == index ? 'green' : 'up'"
                      >修改</label
                    >
                  </label>
                </P>
              </div>
              <div class="floR" @click="addsType" v-if="show_jia == false">
                <span class="pal7">+</span>新增产品分类
              </div>
              <div class="cao" v-else>
                <el-input
                  v-model="input4"
                  placeholder="请输入需型号添加"
                  class="inp170"
                ></el-input>
                <div class="keep hold" @click="baocun">保存</div>
              </div>
            </div>
            <div class="baright">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 12 }"
                placeholder="请输入内容"
                v-model="textarea2"
                class="textInput"
              ></el-input>
            </div>
          </div>
        </div>
      </div>
      <div><hr style="margin-top: 30px" /></div>
      <!-- 联系信息 -->
      <div class="padd">
        <div class="fleft">
          <div class="lianxi">联系信息</div>
          <div class="flex">
            <div class="posR">
              <i class="phone"></i>
              <i
                style="
                  color: red;
                  margin-top: 22px;
                  position: absolute;
                  margin-left: 7px;
                "
                >*</i
              >
              <el-input
                v-model="input5"
                placeholder="请填写您的联系方式"
                class="inp220"
                @change="tel"
                :id="oInputId ? 'redInput' : 'oInput'"
              ></el-input>
              <span v-if="oInputId" class="tishi">请输入正确的手机号</span>
            </div>
          </div>
          <div class="flex">
            <div class="shopImg">
              <i class="shop"></i>
              <el-input
                v-model="input6"
                placeholder="请填写您的淘宝地址"
                class="inp220"
              ></el-input>
            </div>
          </div>
          <div>
            <div class="imgtow" @click="a" v-if="DataId != ''">
              <i class="tow"></i><span>点击绑定客服微信</span
              ><label v-if="IsBindWx">*已获取，等待提交</label>
            </div>
            <div>
              <el-upload
                class="upload-demo floR weima"
                :action="url"
                :on-success="handlePreview"
                :data="data"
                list-type="picture"
                :class="weixinImg ? 'kong' : ''"
                style="text-align: left"
              >
                <div
                  size="small"
                  type="primary"
                  style="width: 180px; text-align: center"
                >
                  上传微信二维码
                </div>
                <label v-if="weixinImg" style="position: relative; top: -4px"
                  >*已获取，等待提交</label
                >
              </el-upload>
            </div>
          </div>
          <div :class="weixinImg ? 'isyes' : ''">
            <span class="chantype">是否参与活动：</span>
            <el-radio v-model="radioList" label="true">是</el-radio>
            <el-radio v-model="radioList" label="false">否</el-radio>
          </div>
        </div>
        <div class="LB_XS">
          <div class="chantype">产品类别</div>
          <i
            style="
              color: red;
              margin-top: 28px;
              position: absolute;
              margin-left: -17px;
            "
            >*</i
          >
          <el-select
            v-model="value1"
            value-key="selectItemId"
            placeholder="选择产品类别"
            @change="selectId(value1)"
          >
            <el-option
              v-for="item in infotypes"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            ></el-option>
          </el-select>
          <div class="" style="width: 253px; display: inline-block">
            <i
              style="
                color: red;
                margin-top: 28px;
                position: absolute;
                margin-left: -17px;
              "
              >*</i
            >
            <div
              class="type"
              v-for="(item, index) in voteList"
              :key="index"
              :class="{ typle: item.state }"
            >
              <label class="vote-more-checkbox padin">
                <span class="check-title" :class="{ font: item.state }">{{
                  item.Name
                }}</span>
                <input
                  type="checkbox"
                  :value="item.title"
                  v-model="checkedItem"
                  @click="typeClick(item, index)"
                />
                <i :class="item.state == true ? 'min_hook' : 'min_hook1'"></i>
              </label>
            </div>
          </div>
          <div style="margin-top: 20px">
            <span class="chantype">结束时间：</span>
            <input type="date" class="data_input" v-model="day" />
          </div>
        </div>
        <div class="mar18 fleft" style="width: 534px">
          <i
            style="
              color: red;
              margin-top: -14px;
              position: absolute;
              margin-left: -11px;
            "
            >*</i
          >
          <div class="lianxi biao">标签选择</div>
          <div class="">
            <div
              class="type_span"
              v-for="(item, index) in LayeList"
              :key="index"
              :class="{ baging: item.state }"
            >
              <label class="vote-more-checkbox linhe">
                <span class="check-title" :class="{ fontfff: item.state }">{{
                  item.title
                }}</span>
                <input
                  type="checkbox"
                  :value="item.title"
                  v-model="checkedlabel"
                  @click="labelClick(item, index)"
                />
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--微信弹窗-->
    <el-dialog
      title="扫码绑定客服微信"
      :visible.sync="dialogVisibles"
      class="tanchuan"
    >
      <div class="flex">
        <div class="center">
          <div>
            <div id="qrCode" ref="qrCodeDiv"></div>
            <span class="width252" style="margin-top: 12px">
              使用微信扫二维码，与
              <span style="color: #00ad66; font-weight: 600">产品绑定</span
              >，绑定后产品的预定信息将会直接推送到微信</span
            >
          </div>
        </div>
        <div class="center maLeft64">
          <i class="qrcode_iduilv_4"></i><br />
          <span class="width252" style="margin-top: 12px"
            >关注<span style="color: #00ad66; font-weight: 600"
              >堆绿云公众号</span
            >，关注后才会收到产品的预定推送信息</span
          >
        </div>
      </div>
    </el-dialog>
    <div class="baocun" @click="baoToPClick">
      <div class="baobtn hold">保存此面板信息</div>
    </div>
  </div>
</template>
<script>
import QRCode from "qrcodejs2";
import "swiper/dist/css/swiper.css";
import "../../../../../html/pages/mall/details/details.scss";

import "../../../../../html/pages/mall/details/details.css";
import "../../../../../html/pages/mall/details/detailBack.css";
import detailVideo from "./detail-video";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapState, mapMutations } from "vuex";
import {
  AddStoreInfo,
  GetTypes,
  GetTags,
  Details,
  UpdateStoreInfo,
} from "../../../../../api/index.js";

export default {
  name: "detailEdit",
  components: {
    swiper,
    swiperSlide,
    detailVideo,
  },
  data() {
    return {
      url: "/Api/Common/UploadImage",
      method: "post", // 方式一定是post
      data: {
        isThumb: false,
      },
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 10,
        simulateTouch: false,
        prevButton: ".cover-prev",
        nextButton: ".cover-next",
      },
      dialogVisible: false,
      dialogVisibles: false,
      dialogImageUrl: "",
      addForm: { files: [] },
      types: [],
      voteList: [],
      LayeList: [],
      modelList: [],
      value: "",
      value1: "",
      input1: "",
      input2: "",
      input_seo: "",
      input_Pc: "",
      input_M: "",
      input3: "",
      input_Activity: "",
      input4: "",
      input5: "",
      input6: "",
      textarea2: "",
      checkedlabel: [],
      lvNum: [],
      checkedItem: [],
      oInputId: false,
      hovernum: 0,
      show_jia: false,
      modelnum: -1,
      selectItemId: "",
      DataId: "",
      weixinImg: "",
      IsBindWx: "",
      infotypes: [],
      infotypesItem: [],
      SubTypes: [],
      selectItemIds: -1,
      tureF: false,
      SubTypesss: [],
      radioList: "false",
      day: "",
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    // 上传成功时的钩子
    uploadSuccess(response, file, fileList) {
      let files = { url: response.Data };
      this.addForm.files.push(files);
    },
    // 删除图片
    handleRemove(file, fileList) {
      for (var i in this.addForm.files) {
        for (var k in this.addForm.files[i]) {
          if (this.addForm.files[i][k] == file.uid) {
            delete this.addForm.files[i];
            break;
          }
        }
      }
    },
    //查看大图
    handlePictureCardPreview(file, fileList) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    //类型
    typeClick(item, index) {
      item.state = !item.state;
      if (item.state && item.Id !== undefined) {
        this.checkedItem.push(item.Id);
      } else {
        if (index > -1) {
          this.checkedItem.forEach(function (items, indexs, arr) {
            if (items == item.Id) {
              arr.splice(indexs, 1);
            }
          }); //首先判断该索引值存在，其次再通过splice删除该位置的元素
        }
      }
    },
    suJClick(item, index) {
      item.state = !item.state;
      if (
        item.state &&
        item.Id !== undefined &&
        this.selectItemIds == item.StoreTypeId
      ) {
        this.infotypesItem.push(item.Id);
      } else {
        if (index > -1) {
          this.infotypesItem.forEach(function (items, indexs, arr) {
            if (items == item.Id) {
              arr.splice(indexs, 1);
            }
          }); //首先判断该索引值存在，其次再通过splice删除该位置的元素
        }
      }
    },
    //标签
    labelClick(item, index) {
      item.state = !item.state;
      if (item.state) {
        this.lvNum.push(item.id);
      } else {
        if (index > -1) {
          this.lvNum.forEach(function (items, indexs, arr) {
            if (items == item.id) {
              arr.splice(indexs, 1);
            }
          });
        }
      }
    },
    async baoToPClick(item, i) {
      if (this.DataId == "") {
        var fileList = [];
        this.addForm.files.forEach(function (item) {
          fileList.push(item.url);
        });
        //图片地址
        var str = "";
        for (var i = 0; i < fileList.length; i++) {
          str += fileList[i] + ",";
        }
        //去掉最后一个逗号(如果不需要去掉，就不用写)
        if (str.length > 0) {
          str = str.substr(0, str.length - 1);
        }
        //产品类别id
        var str1 = "";
        for (var j = 0; j < this.checkedItem.length; j++) {
          //遍历item变量里的对象的属性和元素,
          if (this.checkedItem[j] !== undefined) {
            str1 += this.checkedItem[j] + ","; //将obj对象的属性遍历出来，并且追加到str1字符中。
          }
        }
        if (str1.length > 0) {
          str1 = str1.substr(0, str1.length - 1);
        }
        //标签id
        var str2 = "";
        for (var a = 0; a < this.lvNum.length; a++) {
          str2 += this.lvNum[a] + ",";
        }
        if (str2.length > 0) {
          str2 = str2.substr(0, str2.length - 1);
        }
        //=this.infotypesItem.join(',')
        var str3 = "";
        for (var a = 0; a < this.infotypesItem.length; a++) {
          if (this.infotypesItem[a] !== undefined) {
            str3 += this.infotypesItem[a] + ",";
          }
        }
        if (str3.length > 0) {
          str3 = str3.substr(0, str3.length - 1);
        }
        if (str == "") {
          this.$message.error("请上传图片");
          return;
        }
        if (
          !/^\d+\.?\d{0,2}$/.test(this.input3) ||
          !/^\d*\.?\d{0,2}$/.test(this.input_Activity)
        ) {
          console.log(this.input3);
          this.$message.error("请输入有效的淘宝价或活动价");
          return;
        }
        if (
          this.input1 == "" ||
          this.selectItemId == "" ||
          str3 == "" ||
          this.modelList == "" ||
          this.textarea2 == "" ||
          this.input5 == "" ||
          str1 == "" ||
          str2 == ""
        ) {
          // console.log(this.input1)
          // console.log(this.selectItemId)
          // console.log(this.modelList)
          // console.log(this.textarea2)
          // console.log(this.input5)
          // console.log(str1)
          // console.log(str2)
          this.$message.error("有*号的为必填项哦！！！");
          return;
        }
        console.log("----------------");
        console.log(this.selectItemId);
        if (this.$refs.detailVideo.goodsVideo != null) {
          let res = await AddStoreInfo({
            Name: this.input1, //商品名称
            SEOKeyWord: this.input2, //seo关键字
            SEODescription: this.input_seo, //seo描述
            ActivityPcUrl: this.input_Pc,
            ActivityMUrl: this.input_M,
            QRCode: this.weixinImg, //微信图片地址
            StoreSubTypeId: this.selectItemId, //产品分类id
            StoreSubTypeIds: str3,
            StoreProductTypeIds: str1, //产品类别id
            PicPaths: str, //图片地址
            VideoPath: this.$refs.detailVideo.goodsVideo, //视频地址
            Phone: this.input5, //手机号
            TaobaoUrl: this.input6, //淘宝链接地址
            Price: this.input3, //价格
            ActivityPrice: this.input_Activity,
            ModelList: JSON.stringify(this.modelList), //型号列表
            Descrption: this.textarea2, //商品简介
            YzkTagIds: str2, //标签id
            IsActivity: this.radioList, //是否参见活动
            ActivityEndTime: this.day, //结束时间
            token: this.userInfo.token, //token
          });
          if (res.Type == "Success") {
            this.DataId = res.Data;
            this.$emit("delCheckFun", this.DataId, this.input5, this.weixinImg);
            this.$message({ message: res.Content, type: "success" });
          } else {
            this.$message.error(res.Content);
          }
        }
      } else {
        this.UpdateStoreInfo();
      }
    },
    async UpdateStoreInfo() {
      var fileList = [];
      var _this = this;
      this.addForm.files.forEach(function (item) {
        fileList.push(item.url);
      });
      //图片地址
      var str = "";
      for (var i = 0; i < fileList.length; i++) {
        str += fileList[i] + ",";
      }
      //去掉最后一个逗号(如果不需要去掉，就不用写)
      if (str.length > 0) {
        str = str.substr(0, str.length - 1);
      }
      //产品类别id
      var str1 = "";
      for (var j = 0; j < this.checkedItem.length; j++) {
        //遍历item变量里的对象的属性和元素,
        if (this.checkedItem[j] !== undefined) {
          str1 += this.checkedItem[j] + ","; //将obj对象的属性遍历出来，并且追加到str1字符中。
        }
      }
      if (str1.length > 0) {
        str1 = str1.substr(0, str1.length - 1);
      }
      //标签id
      var str2 = "";
      for (var a = 0; a < this.lvNum.length; a++) {
        str2 += this.lvNum[a] + ",";
      }
      if (str2.length > 0) {
        str2 = str2.substr(0, str2.length - 1);
      }
      // var str3=this.infotypesItem.join(',')
      var str3 = "";
      for (var a = 0; a < this.infotypesItem.length; a++) {
        if (this.infotypesItem[a] !== undefined) {
          str3 += this.infotypesItem[a] + ",";
        }
      }
      if (str3.length > 0) {
        str3 = str3.substr(0, str3.length - 1);
      }
      if (str == "") {
        this.$message.error("请上传图片");
        return;
      }
      if (
        !/^\d+\.?\d{0,2}$/.test(this.input3) ||
        !/^\d*\.?\d{0,2}$/.test(this.input_Activity)
      ) {
        this.$message.error("请输入有效的淘宝价或活动价");
        return;
      }

      if (
        this.input1 == "" ||
        this.selectItemId == "" ||
        str3 == "" ||
        this.infotypesItem == [] ||
        this.modelList == "" ||
        this.textarea2 == "" ||
        this.input5 == "" ||
        str1 == "" ||
        str2 == ""
      ) {
        console.log(this.input1);
        console.log(this.selectItemId);
        console.log(this.modelList);
        console.log(this.textarea2);
        console.log(this.input5);
        console.log(str1);
        console.log(str2);
        console.log(this.infotypesItem);
        this.$message.error("有*号的为必填项哦！！！");
        return;
      }
      let res = await UpdateStoreInfo({
        id: this.DataId,
        Name: this.input1, //商品名称
        SEOKeyWord: this.input2, //关键字
        SEODescription: this.input_seo, ////seo描述
        ActivityPcUrl: this.input_Pc,
        ActivityMUrl: this.input_M,
        QRCode: this.weixinImg, //微信图片地址
        StoreSubTypeId: this.selectItemId, //产品分类id
        StoreProductTypeIds: str1, //产品类别id
        StoreSubTypeIds: str3,
        PicPaths: str, //图片地址
        VideoPath: this.$refs.detailVideo.goodsVideo, //视频地址
        Phone: this.input5, //手机号
        TaobaoUrl: this.input6, //淘宝链接地址
        Price: this.input3, //价格
        ActivityPrice: this.input_Activity,
        ModelList: JSON.stringify(this.modelList), //型号列表
        Descrption: this.textarea2, //商品简介
        YzkTagIds: str2, //标签id
        IsActivity: this.radioList, //是否参见活动
        ActivityEndTime: this.day, //结束时间
        token: this.userInfo.token, //token
      });
      if (res.Type == "Success") {
        // this.DataId = res.Data
        this.$emit("delCheckFun", this.DataId, this.input5, this.weixinImg);
        console.log(this.weixinImg);
        this.$message({ message: res.Content, type: "success" });
      } else {
        this.$message.error(res.Content);
      }
    },
    modify(item, index) {
      this.show_jia = true;
      this.input4 = item;
      this.modelnum = index;
    },
    deletes(index) {
      this.modelList.splice(index, 1);
    },
    //鼠标移进去
    videoPlayback(item, index) {
      this.hovernum = index;
    },
    //鼠标离开
    videoStopped() {
      this.hovernum = -1;
    },
    handlePreview(response, file, fileList) {
      this.weixinImg = response.Data;
    },
    addsType() {
      this.show_jia = true;
      this.input4 = "";
      this.modelnum = -1;
    },
    baocun() {
      this.show_jia = false;
      var i = this.modelnum;
      if (i == -1) {
        this.modelList.push(this.input4);
        this.input4 = "";
      } else {
        this.modelList.splice(i, 1, this.input4);
      }
    },
    tel() {
      if (!/^1[345789]\d{9}$/.test(this.input5)) {
        // alert("请输入正确的手机号");
        this.oInputId = true;
        this.input5 = "";
        return;
      } else {
        this.oInputId = false;
      }
    },
    selectId(item) {
      this.selectItemId = item;
    },
    async selectIds(item) {
      var _this = this;
      this.selectItemIds = item;
      this.tureF = true;
      this.infotypesItem = [];
      this.checkedItem = [];
      this.SubTypes = "";
      let res = await GetTypes();
      if (res.Type == "Success") {
        res.Data.subtypes.forEach(function (item) {
          _this.$set(item, "state", false);
        });
        setTimeout(function () {
          _this.SubTypes = res.Data.subtypes;
        }, 500);
        res.Data.protypes.forEach(function (item) {
          _this.$set(item, "state", false);
        });
        this.voteList = res.Data.protypes;
      }
    },
    async GetTypes() {
      var _this = this;
      let res = await GetTypes();
      if (res.Type == "Success") {
        this.types = res.Data.types;
        if (this.DataId != "") {
          res.Data.subtypes.forEach(function (item) {
            _this.$set(item, "state", false);
          });
          _this.SubTypes = res.Data.subtypes;
        }
        res.Data.protypes.forEach(function (item) {
          _this.$set(item, "state", false);
        });
        this.voteList = res.Data.protypes;
        this.infotypes = res.Data.infotypes;
      } else {
        this.$layer.alert(res.Content);
      }
    },
    async GetTags() {
      var _this = this;
      let res = await GetTags();
      if (res.Type == "Success") {
        res.Data.forEach(function (item) {
          _this.$set(item, "state", false);
        });
        this.LayeList = res.Data;
      } else {
        this.$layer.alert(res.Content);
      }
    },
    a() {
      this.dialogVisibles = true;
      var _this = this;
      setTimeout(function () {
        _this.bindQRCode();
      }, 50);
    },
    // 生成二维码
    bindQRCode() {
      var _this = this;
      new QRCode(_this.$refs.qrCodeDiv, {
        text: "https://www.iduilv.com/Api/Store/BindWeixin/?id=" + _this.DataId,
        width: 180,
        height: 180,
        colorDark: "#000", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        //   correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
      });
    },
    async Update() {
      var _this = this;
      let res = await Details({
        id: this.DataId,
      });
      if (res.Type == "Success") {
        var data = res.Data.good;
        this.checkedItem = data.StoreProductTypeIds; //产品类别id
        this.infotypesItem = data.StoreTypeIds;

        this.selectItemIds = res.Data.parentTypeId;
        this.tureF = true;

        this.voteList.forEach(function (te) {
          _this.checkedItem.forEach(function (i) {
            if (te.Id == i) {
              te.state = true;
            }
          });
        });
        this.SubTypes.forEach(function (te) {
          _this.infotypesItem.forEach(function (i) {
            if (te.Id == i) {
              te.state = true;
            }
          });
        });
        var PicPaths = data.PicPaths.split(",");
        for (var a = 0; a < PicPaths.length; a++) {
          _this.addForm.files.push({ url: PicPaths[a] });
        }
        this.selectItemId = data.StoreTypeId;
        this.IsBindWx = data.IsBindWx;
        this.value = res.Data.parentTypeId;
        this.value1 = data.StoreTypeId;
        this.radioList = res.Data.isActivity.toString();
        this.day = res.Data.ActivityEndTime;
        (this.input1 = data.Name), //商品名称
          (this.input2 = res.Data.seoKeyWord), //SEO关键字
          (this.input_seo = res.Data.seoDescription), //seo描述
          (this.input_Pc = res.Data.ActivityPcUrl);
        (this.input_M = res.Data.ActivityMUrl),
          console.log(this.input2, this.input_seo);
        (this.weixinImg = data.QRCode), //微信图片地址
          (this.input5 = data.Phone); //手机号
        (this.input6 = data.TaobaoUrl), //淘宝链接地址
          (this.input3 = data.Price), //价格
          (this.input_Activity = data.ActivityPrice),
          (this.modelList = JSON.parse(data.ModelList)); //型号列表
        this.textarea2 = data.Descrption; //商品简介
        this.lvNum = data.YzkTagIds.split(","); // 标签Id
        this.LayeList.forEach(function (item) {
          _this.lvNum.forEach(function (text) {
            if (item.id == text) {
              item.state = true;
            }
          });
        });
      } else {
        this.$message.error(res.Content);
      }
    },
  },
  mounted() {},
  created() {
    if (this.$route.query.id) {
      this.DataId = this.$route.query.id;
      var _this = this;
      setTimeout(function () {
        _this.Update();
      }, 1500);
    }
    this.GetTypes();
    this.GetTags();
  },
};
</script>
<style>
.el-radio__input.is-checked .el-radio__inner {
  border-color: #00ad66;
  background: #00ad66;
}
.el-radio__input.is-checked + .el-radio__label {
  color: #00ad66;
}
.el-radio__inner:hover {
  border-color: #00ad66;
}
.LB_XS {
  width: 324px;
}
.data_input {
  padding: 5px 7px;
  width: 165px;
  border: 1px solid #ccc;
  color: #4d4d4d;
  font-size: 14px;
}
.el-radio-group {
  margin-left: 10px;
}
</style>